import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=33401b30&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=ts&"
export * from "./LandingHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=33401b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33401b30",
  null
  
)

export default component.exports